export type PluralTemplate = { one: string; other: string }

// `templates` carries the raw i18n templates (with a literal %{count} token) straight
// from Rails' pluralization hash — the count itself is only known client-side.
export function pluralize(count: number, templates: PluralTemplate): string {
  const template = count === 1 ? templates.one : templates.other
  return template.replace('%{count}', String(count))
}
